// import request from '@/utils/request'
import axios from 'axios'
import global from '@/global/variable.js'

// 微信登录
export function wxLogin(data) {
  let url = global.requestUrl + '/wx/login'
  if (data.code) {
    url = url + '?code=' + data.code
  }
  return axios.post(url, data)
}

// 用户登录
export function login(data) {
  const url = global.requestUrl + '/login'
  return axios.post(url, data, {headers: {
    'Content-Type':'multipart/form-data'
  }})
}

// 获取用户信息
export function isLogin() {
  const url = global.requestUrl + '/login/isLogin'
  return axios.get(url)
}

// 退出登录
export function logout() {
  const url = global.requestUrl + '/logout'
  return axios.get(url)
}

// 获取用户信息
export function getSelf() {
  const url = global.requestUrl + '/login/success'
  return axios.get(url)
}

// 更新用户信息
export function updatePassword(data) {
  const url = global.requestUrl + '/user/updatePassword'
  return axios.post(url, data)
}